import { graphql } from 'react-relay';

const UpdateTaskMutation = graphql`
    mutation UpdateTaskMutation($input: TaskTypeInput!) {
        updateTask(input: $input) {
            id
            schedule_item_id
            assignee_for_task
            scheduleItem {
                name
            }
            ...TaskFragment
        }
    }
`;

export default UpdateTaskMutation;
